import {
  SUPPORT_ARTICLE_QUICK_TOUR_ROUTE,
  SUPPORT_ARTICLE_SHOP_WITH_CREDITS_ROUTE,
  SUPPORT_ARTICLE_FIRST_DELIVERY_ROUTE,
  SUPPORT_ARTICLE_FOOD_PROFILE_ROUTE,
  SUPPORT_ARTICLE_SCHEDULE_MANAGEMENT_ROUTE,
  SUPPORT_ARTICLE_DELIVERY_ISSUES_ROUTE,
  SUPPORT_ARTICLE_EDIT_ORDER_ROUTE,
  SUPPORT_ARTICLE_EDIT_PLAN_ROUTE,
  ORDER_ROUTE,
  PLAN_ROUTE,
  WALLET_ROUTE,
  MY_HUNGRYROOT_ROUTE,
  ORDER_DETAILS_ROUTE,
  HOMEPAGE_ROUTE,
  REVIEWS_ROUTE,
  LEADERSHIP_ROUTE,
  PHILOSOPHY_ROUTE,
  PACKAGING_ROUTE,
  TERMS_ROUTE,
  ACCESSIBILITY_ROUTE,
  PRIVACY_ROUTE,
  PRIVACY_STATE_ROUTE,
  CA_EMPLOYEE_PRIVACY_POLICY_ROUTE,
  GIFT_ROUTE,
  GIFT_SUBMIT_CLAIM_CODE_ROUTE,
  CAREERS_ROUTE,
} from '@hungryroot/routes';

export const RECIPE_PAGE_NAME_MAPPINGS = {
  is_breakfast: 'breakfast',
  is_lunch: 'lunch',
  is_kids_meals: 'kids_meals',
  is_family_meals: 'family_meals',
  is_tacos: 'tacos',
  is_stir_fries: 'stir_fries',
  is_bakes: 'bakes',
  is_pastas: 'pastas',
  is_pizza: 'pizza',
  is_main_sides: 'main_sides',
  is_burgers: 'burgers',
  is_bowls: 'bowls',
  is_salads: 'salads',
  is_sandwiches: 'sandwiches',
  is_soups_stews: 'soups_stews',
  is_wraps: 'wraps',
  is_starters_and_sides: 'starters_sides',
};

export const GROCERIES_PAGE_NAME_MAPPINGS = {
  is_supplements: 'supplements',
  is_ready_to_eat: 'meals',
  is_kids: 'kids',
  is_produce: 'produce',
  is_sauces_condiments: 'sauces_condiments',
  is_meat_seafood: 'meat_seafood',
  is_plant_proteins: 'plant_based_proteins',
  is_grains_pastas: 'grains_pastas',
  is_bread_bakery: 'bread_bakery',
  is_cereal_oats: 'cereal_oats',
  is_snacks: 'snacks',
  is_sweets: 'sweets',
  is_dairy_eggs: 'dairy_eggs',
  is_pantry: 'pantry',
  is_beverages: 'drinks',
  is_sides: 'sides',
};

export const PATH_PAGE_NAME_MAPPINGS = {
  [HOMEPAGE_ROUTE]: 'homepage',
  [MY_HUNGRYROOT_ROUTE]: 'home',
  [ORDER_ROUTE]: 'order_details',
  [ORDER_DETAILS_ROUTE]: 'order_details',
  [PLAN_ROUTE]: 'plan',
  [WALLET_ROUTE]: 'wallet',
  [SUPPORT_ARTICLE_QUICK_TOUR_ROUTE]: 'support_article_quick_tour',
  [SUPPORT_ARTICLE_SHOP_WITH_CREDITS_ROUTE]:
    'support_article_shop_with_credits',
  [SUPPORT_ARTICLE_FIRST_DELIVERY_ROUTE]: 'support_article_first_delivery',
  [SUPPORT_ARTICLE_FOOD_PROFILE_ROUTE]: 'support_article_food_profile',
  [SUPPORT_ARTICLE_SCHEDULE_MANAGEMENT_ROUTE]:
    'support_article_schedule_management',
  [SUPPORT_ARTICLE_DELIVERY_ISSUES_ROUTE]: 'support_article_delivery_issues',
  [SUPPORT_ARTICLE_EDIT_ORDER_ROUTE]: 'support_article_edit_order',
  [SUPPORT_ARTICLE_EDIT_PLAN_ROUTE]: 'support_article_edit_plan',
  [REVIEWS_ROUTE]: 'reviews',
  [LEADERSHIP_ROUTE]: 'leadership',
  [PHILOSOPHY_ROUTE]: 'philosophy',
  [PACKAGING_ROUTE]: 'packaging',
  [TERMS_ROUTE]: 'terms',
  [ACCESSIBILITY_ROUTE]: 'accessibility',
  [PRIVACY_ROUTE]: 'privacy',
  [PRIVACY_STATE_ROUTE]: 'privacy_state',
  [CA_EMPLOYEE_PRIVACY_POLICY_ROUTE]: 'privacy_ca_employee_notice',
  [GIFT_ROUTE]: 'gift',
  [GIFT_SUBMIT_CLAIM_CODE_ROUTE]: 'gift_submit_claim_code',
  [CAREERS_ROUTE]: 'careers',
};
